class CompanySettingsTracking extends React.Component {

  static contextTypes = {
    utils: PropTypes.object.isRequired
  };

  state = {
    uiFields: {}
  };

  componentDidMount() {
    // DEBUG
    console.log('CompanySettingsTracking.componentDidMount: props: %o', this.props);

    this.loadFreshCompanyData();
  }

  loadFreshCompanyData = callback => {
    this.context.utils.companyDataLoad(function(companyData) {
      this.setState({
        uiFields: {
          gaTrackingId: (((companyData.analytics || {}).ga || {}).trackingId || '')
        }
      }, callback);
    }.bind(this));
  };

  render() {
    return (
      <div className="company-settings company-settings-tracking-disabled">
        <h3 className="u-m0">Google Analytics Tracking ID</h3>
        <div className="help-block">Enable to track page views on battlecards &amp; company profiles. Leave blank to disable.</div>
        <input type="text" className="form-control input-disabled" placeholder="eg. UA-XXXXXXXX-X" value={this.state.uiFields.gaTrackingId} disabled={true} />
        <div className="row u-pt-m">
          <div className="col-sm-4"><div className="btn btn-disabled" style={{width: '100%'}} disabled={true}>Save</div></div>
        </div>
      </div>
    );
  }

}

export default CompanySettingsTracking;
